import { faGears, faScaleBalanced } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { CreateLegalDocumentForm } from '~/components/forms/LegalDocumentForm';
import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { Heading } from '~/components/molecules/Heading';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { useNavigate } from '~/components/utils/Navigation';

export type ICreateLegalDocumentPageProps = {
  appId: string;
};

export const AppCreateLegalDocumentPage: React.FC<
  ICreateLegalDocumentPageProps
> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const parentUrl = `/apps/${appId}/settings/legalDocuments`;

  return (
    <>
      <Helmet>
        <title>{t('AppCreateLegalDocumentPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={`/apps/${appId}/settings`}>
          <FontAwesomeIcon icon={faGears} />
          {t('common.settings')}
        </Breadcrumbs.Action>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faScaleBalanced} />
          {t('AppLegalDocumentsPage.title')}
        </Breadcrumbs.Action>
      </AppBreadcrumbs>

      <Heading
        title={t('AppCreateLegalDocumentPage.title')}
        previousUrl={parentUrl}
      />

      <CreateLegalDocumentForm
        appId={appId}
        onSuccess={(createdLegalDocument) =>
          navigate(
            `/apps/${createdLegalDocument.appId}/settings/legalDocuments`,
          )
        }
        cancelUrl={parentUrl}
      />
    </>
  );
};
